import './index.less';

export function PageNotFound() {
  return (
    <div className="pagenotfound-wrapper">
      <p>
        <span className="title-wrapper">
          <span className="text-main">404</span>
          <span className="text-bg">404</span>
        </span>
      </p>
      <p className="text-desc">
        从前有座山，山里有座庙，庙里有个页面，现在找不到...
      </p>
      <p>
        <a className="mag-btn mag-btn--primary" href="/">
          返回首页
        </a>
      </p>
    </div>
  );
}
